/* eslint-disable react/jsx-curly-newline */
/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';

// components
import { Grid, Input } from '@design-system-coopeuch/web';
import SimpleCard from '../../molecules/SimpleCard/SimpleCard';

// utils
import { toCurrencyFormat } from '../../../../domain/utils/utilitarios-frontend-coopeuch/currency';

// styles
import { StyledGridFees } from './styles';

// assets
import iconInfo from '../../../assets/img/icon-info.svg';

const CardParticipationFees = (props) => {
  const {
    monthlyFees,
    monthlyInvestment,
    participationFeesParams,
    isValidMonthlyFee,
    onChange,
  } = props;

  return (
    <SimpleCard
      contentHeader={
        <p className="simplecard__title">Elige tu cantidad mensual de tus cuotas de participación</p>
      }
    >
      <>
        <Grid className="m-0 padding-16 p-md-6">
          <Grid className="mb-2 p-0" col={12}>
            <p className="font-size-14 line-height-22">
              <strong className="text-color-info">1 cuota </strong>
              de participación es igual a
              <strong className="text-color-info">{` $${participationFeesParams.value}`}</strong>
              {`, según el valor año en curso. Puedes invertir entre ${participationFeesParams.minMonthlyFee} a ${participationFeesParams.maxMonthlyFee} cuotas mensuales.`}
            </p>
          </Grid>
          <StyledGridFees className="p-0" col={12}>
            <Grid className="p-0 d-flex align-items-center align-items-md-start flex-column">
              <p className="font-size-16 line-height-30 font-weight-bold text-center text-md-left">
                Cuotas por mes
              </p>
              <Input
                value={monthlyFees.value}
                assistText={[
                  {
                    text: `Mínimo ${participationFeesParams.minMonthlyFee}, máximo ${participationFeesParams.maxMonthlyFee}`,
                    type: isValidMonthlyFee ? 'assist' : 'error',
                  },
                ]}
                onChange={(e) =>
                  onChange({
                    field: 'monthlyFees',
                    property: 'value',
                    value: e,
                  })
                }
                onlyNumber
                maxLength={3}
              />
            </Grid>
            <Grid className="p-0 d-flex justify-content-center align-items-center">
              <p className="text-equal text-center">=</p>
            </Grid>
            <Grid className="p-0 d-flex flex-column justify-content-center">
              <p className="font-size-16 line-height-30 font-weight-bold text-center">
                Tu inversión mensual
              </p>
              <p
                className={`p-2 ${
                  isValidMonthlyFee ? 'text-color-info' : 'text-color-disabled'
                }  text-center font-size-32 font-weight-bold line-height-38`}
              >
                {toCurrencyFormat(monthlyInvestment.value)}
              </p>
            </Grid>
          </StyledGridFees>
          <Grid className="p-0 m-0 mt-4 d-flex align-items-center">
            <img src={iconInfo} alt='icon-info' width="14" />
            <p className="ml-2">Puedes cambiar tu cantidad de cuotas pactadas cuando lo desees con atención de un ejecutivo. </p>
          </Grid>
        </Grid>
      </>
    </SimpleCard>
  );
};

CardParticipationFees.defaultProps = {
  monthlyInvestment: {
    value: 0,
  },
  monthlyFees: {
    value: 0,
  },
  participationFeesParams: {
    value: 0,
    minMonthlyFee: 0,
    maxMonthlyFee: 0,
  },
  authorizationPaymentFirstFee: {
    value: false,
  },
  isValidMonthlyFee: false,
  onChange: () => null,
};

CardParticipationFees.propTypes = {
  monthlyInvestment: PropTypes.shape({
    value: PropTypes.number,
  }),
  monthlyFees: PropTypes.shape({
    value: PropTypes.number,
  }),
  participationFeesParams: PropTypes.shape({
    value: PropTypes.number,
    minMonthlyFee: PropTypes.number,
    maxMonthlyFee: PropTypes.number,
  }),
  authorizationPaymentFirstFee: PropTypes.shape({
    value: PropTypes.bool,
  }),
  isValidMonthlyFee: PropTypes.bool,
  onChange: PropTypes.func,
};

export default CardParticipationFees;
